
import { Component, Vue, Emit } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { IUser } from '@/api/types'

@Component
export default class UserInfoCard extends Vue {
  get userInfo(): IUser | null {
    return UserModule.userInfo
  }

  public formatTime(time: string | null): string {
    // console.log(time)
    if (!time) return '-'
    return new Date(time).toLocaleString()
  }

  @Emit('edit-username')
  public handleEditUsername() {
    // 通过事件通知父组件打开编辑用户名对话框
    this.$emit('edit-username')
    return true
  }

  @Emit('bind-wechat')
  public handleBindWechat() {
    // 通过事件通知父组件打开绑定微信对话框
    this.$emit('bind-wechat', 'wechat')
    return 'wechat'
  }

  @Emit('bind-phone')
  public handleBindPhone() {
    // 通过事件通知父组件打开绑定手机对话框
    this.$emit('bind-phone', 'phone')
    return 'phone'
  }

  @Emit('reset-password')
  public handleResetPassword() {
    // 通过事件通知父组件打开重置密码对话框
    this.$emit('reset-password')
    return true
  }
}
